import { useState } from "react";
import SectionBox from "../components/SectionBox";
import products from "../data/products";
import ProductGrid from "../components/ProductGrid";

const categories = ["सभी", "पिसे मसाले", "मिक्स मसाले"];

export default function Products() {
    const [active, setActive] = useState("सभी");

    const filteredProducts =
        active === "सभी"
            ? products
            : products.filter((p) => p.category === active);

    return (
        <main className="relative min-h-screen py-24">

            {/* 🔴 TOP BOX */}
            <SectionBox className="max-w-4xl text-center">
                <div className="
        bg-black/50 
        backdrop-blur-sm 
        rounded-3xl 
        px-6 md:px-10 
        py-10
    ">
                    {/* Heading */}
                    <h1 className="text-4xl md:text-5xl font-extrabold text-[#7a0c18]">
                        हमारे उत्पाद
                    </h1>

                    {/* Description */}
                    <p className="mt-4 text-gray-200 text-lg">
                        बालाजी मसाले के शुद्ध, स्वादिष्ट और गुणवत्तापूर्ण मसालों की विस्तृत श्रृंखला।
                    </p>

                    {/* Filters */}
                    <div className="mt-8 flex flex-wrap justify-center gap-4">
                        {categories.map((cat) => (
                            <button
                                key={cat}
                                onClick={() => setActive(cat)}
                                className={`px-6 py-2 rounded-full border font-medium transition
                    ${active === cat
                                        ? "bg-[#7a0c18] text-white border-[#7a0c18]"
                                        : "border-white text-white hover:bg-[#7a0c18] hover:border-[#7a0c18]"
                                    }`}
                            >
                                {cat}
                            </button>
                        ))}
                    </div>
                </div>
            </SectionBox>



            {/* 🔴 PRODUCTS BOX (separate) */}
            <SectionBox className="max-w-7xl mx-auto mt-16">
                <ProductGrid products={filteredProducts} />
            </SectionBox>

        </main>
    );
}
